import React, { useEffect, useState } from 'react';
import { CheckCircle, Clock, AlertTriangle, Users, Package, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackAddToCart, trackInitiateCheckout } from './MetaPixel';
export function CTASection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  const [stockLeft, setStockLeft] = useState(17);
  // Countdown timer effect
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const newSeconds = prev.seconds - 1;
        const newMinutes = newSeconds < 0 ? prev.minutes - 1 : prev.minutes;
        const newHours = newMinutes < 0 ? prev.hours - 1 : prev.hours;
        return {
          hours: newHours < 0 ? 23 : newHours,
          minutes: newMinutes < 0 ? 59 : newMinutes,
          seconds: newSeconds < 0 ? 59 : newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const handlePurchaseClick = () => {
    // Dispara ambos eventos para seguimiento completo
    trackAddToCart();
    trackInitiateCheckout();
  };
  return <section id="cta" className="py-8 bg-blue-700 text-white" data-id="element-63">
      <div className="container mx-auto px-4" data-id="element-64">
        <div className="max-w-4xl mx-auto" data-id="element-65">
          <motion.div className="text-center mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-66">
            <p className="text-xl mb-4" data-id="element-67">
              ✅ Haz clic ahora y permite que tu cuerpo sane como fue diseñado:
              libre, autónomo y en armonía.
            </p>
            <motion.div className="flex items-center justify-center space-x-2 mb-4" animate={{
            scale: [1, 1.05, 1]
          }} transition={{
            repeat: Infinity,
            duration: 2
          }} data-id="element-68">
              <Clock size={20} className="text-yellow-300" data-id="element-69" />
              <p className="font-bold text-yellow-300" data-id="element-70">
                ¡OFERTA POR TIEMPO LIMITADO!
              </p>
            </motion.div>
          </motion.div>
          <div className="bg-white text-gray-800 rounded-2xl overflow-hidden shadow-2xl" data-id="element-71">
            <div className="grid md:grid-cols-2" data-id="element-72">
              <div className="p-8" data-id="element-73">
                <h3 className="text-2xl font-bold mb-4 text-blue-700" data-id="element-74">
                  Gorro Terapéutico RelaxGlow
                </h3>
                <motion.div className="bg-red-100 p-3 rounded-lg mb-6 border-l-4 border-red-500 flex items-center" initial={{
                x: -10,
                opacity: 0
              }} animate={{
                x: 0,
                opacity: 1
              }} transition={{
                delay: 0.3
              }} data-id="element-75">
                  <AlertTriangle size={20} className="text-red-500 mr-2 flex-shrink-0" data-id="element-76" />
                  <p className="text-red-700 text-sm font-medium" data-id="element-77">
                    ¡Solo quedan{' '}
                    <span className="font-bold" data-id="element-78">{stockLeft} unidades</span> al
                    precio promocional!
                  </p>
                </motion.div>
                <motion.div className="mb-6 flex items-center justify-center" animate={{
                scale: [1, 1.03, 1]
              }} transition={{
                repeat: Infinity,
                duration: 1.5
              }} data-id="element-79">
                  <div className="text-center" data-id="element-80">
                    <p className="text-gray-500 text-lg line-through mb-0" data-id="element-81">
                      Precio normal: $50
                    </p>
                    <div className="flex items-center justify-center" data-id="element-82">
                      <span className="text-4xl font-bold text-green-600" data-id="element-83">
                        $25
                      </span>
                      <span className="ml-2 bg-green-100 text-green-800 text-xs font-bold px-2 py-1 rounded" data-id="element-84">
                        50% DESCUENTO
                      </span>
                    </div>
                  </div>
                </motion.div>
                <div className="bg-blue-50 p-3 rounded-lg mb-6 flex items-center justify-center" data-id="element-85">
                  <div className="grid grid-cols-3 gap-2 text-center" data-id="element-86">
                    <div className="bg-blue-600 text-white p-2 rounded" data-id="element-87">
                      <div className="text-xl font-bold" data-id="element-88">
                        {timeLeft.hours.toString().padStart(2, '0')}
                      </div>
                      <div className="text-xs" data-id="element-89">HORAS</div>
                    </div>
                    <div className="bg-blue-600 text-white p-2 rounded" data-id="element-90">
                      <div className="text-xl font-bold" data-id="element-91">
                        {timeLeft.minutes.toString().padStart(2, '0')}
                      </div>
                      <div className="text-xs" data-id="element-92">MINUTOS</div>
                    </div>
                    <div className="bg-blue-600 text-white p-2 rounded" data-id="element-93">
                      <div className="text-xl font-bold" data-id="element-94">
                        {timeLeft.seconds.toString().padStart(2, '0')}
                      </div>
                      <div className="text-xs" data-id="element-95">SEGUNDOS</div>
                    </div>
                  </div>
                </div>
                <ul className="space-y-3 mb-6" data-id="element-96">
                  <li className="flex items-start" data-id="element-97">
                    <CheckCircle size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-98" />
                    <span data-id="element-99">Terapia fría y caliente en un solo dispositivo</span>
                  </li>
                  <li className="flex items-start" data-id="element-100">
                    <CheckCircle size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-101" />
                    <span data-id="element-102">Diseño ergonómico para máxima comodidad</span>
                  </li>
                  <li className="flex items-start" data-id="element-103">
                    <CheckCircle size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-104" />
                    <span data-id="element-105">Fácil de usar en cualquier momento</span>
                  </li>
                  <li className="flex items-start" data-id="element-106">
                    <CheckCircle size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-107" />
                    <span data-id="element-108">Resultados desde las primeras aplicaciones</span>
                  </li>
                  <li className="flex items-start" data-id="element-109">
                    <CheckCircle size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-110" />
                    <span data-id="element-111">Garantía de devolución de dinero por 30 días</span>
                  </li>
                </ul>
                <div className="flex items-center justify-center mb-3 text-sm" data-id="element-112">
                  <Users size={16} className="text-blue-600 mr-1" data-id="element-113" />
                  <span data-id="element-114">
                    <strong data-id="element-115">32 personas</strong> compraron en las últimas 24
                    horas
                  </span>
                </div>
                <div className="text-center" data-id="element-116">
                  <motion.a href="https://shopysv.com/products/pide-tu-gorro-anti-migrana" className="flex items-center justify-center w-full bg-blue-600 hover:bg-blue-700 text-white text-xl font-bold py-4 px-6 rounded-full transition-colors" whileHover={{
                  scale: 1.05
                }} whileTap={{
                  scale: 0.95
                }} onClick={handlePurchaseClick} data-id="element-117">
                    <span data-id="element-118">¡Sí! Quiero mi RelaxGlow AHORA</span>
                    <ArrowRight size={20} className="ml-2" data-id="element-119" />
                  </motion.a>
                  <div className="mt-3 flex items-center justify-center" data-id="element-120">
                    <Package size={16} className="text-gray-500 mr-1" data-id="element-121" />
                    <p className="text-sm text-gray-500" data-id="element-122">
                      Envío GRATIS a todo El Salvador
                    </p>
                  </div>
                  <p className="mt-3 text-xs text-gray-500" data-id="element-123">
                    Lo más caro que puedes hacer es seguir intoxicando tu cuerpo
                    para calmarlo.
                  </p>
                </div>
              </div>
              <div className="bg-gray-100 flex items-center justify-center p-8" data-id="element-124">
                <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6WHmz2MHUmVjXVZHhvnwzy/freepik__cambia-el-color-del-gorro-por-rosado-sin-alterar-n__98289.png" alt="Mujer relajándose con el gorro terapéutico RelaxGlow de color rosa con efectos luminosos azules" className="max-w-full h-auto rounded-lg shadow-lg" initial={{
                scale: 0.9,
                opacity: 0.8
              }} animate={{
                scale: 1,
                opacity: 1
              }} transition={{
                duration: 2,
                repeat: Infinity,
                repeatType: 'reverse'
              }} data-id="element-125" />
              </div>
            </div>
          </div>
          <motion.div className="mt-6 text-center" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} data-id="element-126">
            <p className="text-sm bg-blue-800 inline-block py-2 px-4 rounded-full" data-id="element-127">
              🔒 Pago 100% seguro • Garantía de devolución • Envío rápido
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}